import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "sort-icon"
};
const _hoisted_2 = {
    key: 0,
    class: "sort-icon"
};
const _hoisted_3 = {
    key: 0,
    class: "sort-icon"
};
const _hoisted_4 = {
    key: 0,
    class: "sort-icon"
};
const _hoisted_5 = { class: "col-header col-tags" };
const _hoisted_6 = {
    key: 0,
    class: "sort-icon"
};
const _hoisted_7 = { class: "date-header" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "col-date" };
const _hoisted_10 = { class: "col-merchant" };
const _hoisted_11 = { class: "col-description" };
const _hoisted_12 = { class: "col-category" };
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "col-tags" };
const _hoisted_17 = { class: "tags-truncate" };
const _hoisted_18 = {
    key: 0,
    class: "tags-tooltip"
};
const _hoisted_19 = {
    key: 0,
    class: "transaction-detail-panel"
};
const _hoisted_20 = { class: "detail-grid" };
const _hoisted_21 = { class: "detail-item" };
const _hoisted_22 = { class: "detail-value" };
const _hoisted_23 = {
    key: 0,
    class: "detail-item"
};
const _hoisted_24 = { class: "detail-value" };
const _hoisted_25 = { class: "detail-item" };
const _hoisted_26 = { class: "detail-value" };
const _hoisted_27 = { class: "detail-item" };
const _hoisted_28 = { class: "detail-value" };
const _hoisted_29 = { class: "detail-item full-width" };
const _hoisted_30 = { class: "detail-value" };
const _hoisted_31 = { class: "detail-item full-width" };
const _hoisted_32 = ["onClick"];
const _hoisted_33 = { class: "col-date" };
const _hoisted_34 = { class: "col-merchant" };
const _hoisted_35 = { class: "col-description" };
const _hoisted_36 = { class: "col-category" };
const _hoisted_37 = ["src"];
const _hoisted_38 = ["src"];
const _hoisted_39 = ["onClick"];
const _hoisted_40 = { class: "col-tags" };
const _hoisted_41 = { class: "tags-truncate" };
const _hoisted_42 = {
    key: 0,
    class: "tags-tooltip"
};
const _hoisted_43 = {
    key: 0,
    class: "transaction-detail-panel"
};
const _hoisted_44 = { class: "detail-grid" };
const _hoisted_45 = { class: "detail-item" };
const _hoisted_46 = { class: "detail-value" };
const _hoisted_47 = {
    key: 0,
    class: "detail-item"
};
const _hoisted_48 = { class: "detail-value" };
const _hoisted_49 = { class: "detail-item" };
const _hoisted_50 = { class: "detail-value" };
const _hoisted_51 = { class: "detail-item" };
const _hoisted_52 = { class: "detail-value" };
const _hoisted_53 = { class: "detail-item full-width" };
const _hoisted_54 = { class: "detail-value" };
const _hoisted_55 = { class: "detail-item full-width" };
const _hoisted_56 = {
    key: 2,
    class: "empty-state"
};
import { ref, reactive, computed, onBeforeUnmount } from 'vue';
import TagInput from '../../components/elements/TagInput.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TransactionsTable',
    props: {
        transactions: { default: () => [] },
        colourMode: { default: 'light' },
        formatter: {},
        emptyMessage: { default: 'No transactions found' },
        highlightedTransactionId: { default: null },
        availableTags: { default: () => [] },
        stickyHeaderTop: { default: 0 }
    },
    emits: ["row-click", "tag-click", "tags-change"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const columnWidths = reactive([80, 220, null, 160, 120, 100]);
        const isResizing = ref(false);
        const resizeIndex = ref(null);
        const startX = ref(0);
        const startWidth = ref(0);
        const justResized = ref(false);
        const sortColumn = ref(null);
        const sortDirection = ref('desc');
        const expandedTransactionId = ref(null);
        const selectedTransactionId = ref(null);
        const gridStyle = computed(() => {
            const cols = columnWidths.map(w => w ? `${w}px` : '1fr').join(' ');
            return { gridTemplateColumns: cols };
        });
        const sortedTransactions = computed(() => {
            if (!sortColumn.value || sortColumn.value === 'date') {
                if (sortColumn.value === 'date' && sortDirection.value === 'asc') {
                    return [...props.transactions].reverse().map(g => [...g].reverse());
                }
                return props.transactions;
            }
            const flat = props.transactions.flatMap(group => group);
            flat.sort((a, b) => {
                let valA, valB;
                switch (sortColumn.value) {
                    case 'merchant':
                        valA = (a.merchant?.name || a.merchantName || '').toLowerCase();
                        valB = (b.merchant?.name || b.merchantName || '').toLowerCase();
                        break;
                    case 'description':
                        valA = (a.description || '').toLowerCase();
                        valB = (b.description || '').toLowerCase();
                        break;
                    case 'category':
                        valA = (getClassification(a)?.mgClassification || '').toLowerCase();
                        valB = (getClassification(b)?.mgClassification || '').toLowerCase();
                        break;
                    case 'amount':
                        valA = a.amount;
                        valB = b.amount;
                        break;
                    default:
                        return 0;
                }
                if (valA < valB)
                    return sortDirection.value === 'asc' ? -1 : 1;
                if (valA > valB)
                    return sortDirection.value === 'asc' ? 1 : -1;
                return 0;
            });
            return flat;
        });
        function getClassification(t) {
            return t.customerClassification || t.effectiveClassification || t.originalClassification?.mgClassification;
        }
        function formatDateHeader(dateString) {
            const today = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
            const yesterday = new Date(Date.now() - 86400000).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
            if (dateString === today)
                return 'Today';
            if (dateString === yesterday)
                return 'Yesterday';
            return dateString;
        }
        function startResize(e, index) {
            isResizing.value = true;
            resizeIndex.value = index;
            startX.value = e.clientX;
            startWidth.value = columnWidths[index] || 200;
            document.addEventListener('mousemove', onResize);
            document.addEventListener('mouseup', stopResize);
        }
        function onResize(e) {
            if (!isResizing.value)
                return;
            const diff = e.clientX - startX.value;
            const newWidth = Math.max(50, startWidth.value + diff);
            columnWidths[resizeIndex.value] = newWidth;
        }
        function stopResize() {
            isResizing.value = false;
            resizeIndex.value = null;
            justResized.value = true;
            document.removeEventListener('mousemove', onResize);
            document.removeEventListener('mouseup', stopResize);
            setTimeout(() => { justResized.value = false; }, 0);
        }
        function toggleSort(column) {
            if (justResized.value)
                return;
            if (sortColumn.value === column) {
                sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
            }
            else {
                sortColumn.value = column;
                sortDirection.value = column === 'amount' ? 'desc' : 'asc';
            }
        }
        function toggleExpand(transaction) {
            selectedTransactionId.value = transaction.id;
            if (expandedTransactionId.value === transaction.id) {
                expandedTransactionId.value = null;
            }
            else {
                expandedTransactionId.value = transaction.id;
                emit('row-click', transaction);
            }
        }
        function formatFullDate(timestamp) {
            if (!timestamp)
                return '';
            const date = new Date(timestamp);
            return date.toLocaleDateString('en-GB', {
                weekday: 'long',
                day: 'numeric',
                month: 'short',
                year: '2-digit'
            });
        }
        function getTime(timestamp) {
            if (!timestamp)
                return '';
            return timestamp.split('T')[1]?.split('.')[0] || '';
        }
        function getSelectedTags(transaction) {
            if (transaction.customerTags && Array.isArray(transaction.customerTags)) {
                return transaction.customerTags.map((t) => t.tag);
            }
            return [];
        }
        function handleTagsChange(transaction, tags) {
            emit('tags-change', { transaction, tags });
        }
        function onTagClick(transaction) {
            selectedTransactionId.value = transaction.id;
            emit('tag-click', transaction);
        }
        onBeforeUnmount(() => {
            document.removeEventListener('mousemove', onResize);
            document.removeEventListener('mouseup', stopResize);
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["transactions-table", [_ctx.colourMode, { resizing: isResizing.value }]])
            }, [
                _createElementVNode("div", {
                    class: "table-header",
                    style: _normalizeStyle([gridStyle.value, { top: _ctx.stickyHeaderTop + 'px' }])
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-header col-date sortable", { sorted: !sortColumn.value || sortColumn.value === 'date' }]),
                        onClick: _cache[1] || (_cache[1] = ($event) => (toggleSort('date')))
                    }, [
                        _cache[10] || (_cache[10] = _createTextVNode(" Date ")),
                        (!sortColumn.value || sortColumn.value === 'date')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(sortColumn.value === 'date' && sortDirection.value === 'asc' ? '▲' : '▼'), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            class: "resize-handle",
                            onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event) => (startResize($event, 0)), ["stop"]))
                        }, null, 32)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-header col-merchant sortable", { sorted: sortColumn.value === 'merchant' }]),
                        onClick: _cache[3] || (_cache[3] = ($event) => (toggleSort('merchant')))
                    }, [
                        _cache[11] || (_cache[11] = _createTextVNode(" Merchant ")),
                        (sortColumn.value === 'merchant')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(sortDirection.value === 'asc' ? '▲' : '▼'), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            class: "resize-handle",
                            onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event) => (startResize($event, 1)), ["stop"]))
                        }, null, 32)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-header col-description sortable", { sorted: sortColumn.value === 'description' }]),
                        onClick: _cache[5] || (_cache[5] = ($event) => (toggleSort('description')))
                    }, [
                        _cache[12] || (_cache[12] = _createTextVNode(" Description ")),
                        (sortColumn.value === 'description')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(sortDirection.value === 'asc' ? '▲' : '▼'), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            class: "resize-handle",
                            onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event) => (startResize($event, 2)), ["stop"]))
                        }, null, 32)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-header col-category sortable", { sorted: sortColumn.value === 'category' }]),
                        onClick: _cache[7] || (_cache[7] = ($event) => (toggleSort('category')))
                    }, [
                        _cache[13] || (_cache[13] = _createTextVNode(" Category ")),
                        (sortColumn.value === 'category')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(sortDirection.value === 'asc' ? '▲' : '▼'), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            class: "resize-handle",
                            onMousedown: _cache[6] || (_cache[6] = _withModifiers(($event) => (startResize($event, 3)), ["stop"]))
                        }, null, 32)
                    ], 2),
                    _createElementVNode("div", _hoisted_5, [
                        _cache[14] || (_cache[14] = _createTextVNode(" Tags ")),
                        _createElementVNode("div", {
                            class: "resize-handle",
                            onMousedown: _cache[8] || (_cache[8] = _withModifiers(($event) => (startResize($event, 4)), ["stop"]))
                        }, null, 32)
                    ]),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-header col-amount sortable", { sorted: sortColumn.value === 'amount' }]),
                        onClick: _cache[9] || (_cache[9] = ($event) => (toggleSort('amount')))
                    }, [
                        _cache[15] || (_cache[15] = _createTextVNode(" Amount ")),
                        (sortColumn.value === 'amount')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(sortDirection.value === 'asc' ? '▲' : '▼'), 1))
                            : _createCommentVNode("", true)
                    ], 2)
                ], 4),
                (!sortColumn.value || sortColumn.value === 'date')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(sortedTransactions.value, (group, gIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: gIndex,
                            class: "transaction-group"
                        }, [
                            _createElementVNode("div", _hoisted_7, _toDisplayString(formatDateHeader(group[0]?.timestampString)), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (t) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: t.id
                                }, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["transaction-row", { expanded: expandedTransactionId.value === t.id, highlighted: _ctx.highlightedTransactionId === t.id || selectedTransactionId.value === t.id }]),
                                        style: _normalizeStyle(gridStyle.value),
                                        onClick: ($event) => (toggleExpand(t))
                                    }, [
                                        _createElementVNode("div", _hoisted_9, _toDisplayString(t.timestampString), 1),
                                        _createElementVNode("div", _hoisted_10, _toDisplayString(t.merchant?.name || t.merchantName), 1),
                                        _createElementVNode("div", _hoisted_11, _toDisplayString(t.description), 1),
                                        _createElementVNode("div", _hoisted_12, [
                                            (getClassification(t)?.iconPath)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: require('@/assets/transactions/' + getClassification(t).iconPath.toLowerCase().replace('.svg', '.png')),
                                                    class: "category-icon"
                                                }, null, 8, _hoisted_13))
                                                : (_openBlock(), _createElementBlock("img", {
                                                    key: 1,
                                                    src: require('@/assets/round3.png'),
                                                    class: "category-icon"
                                                }, null, 8, _hoisted_14)),
                                            _createElementVNode("span", null, _toDisplayString(getClassification(t)?.mgSubClassification || getClassification(t)?.mgClassification || 'Uncategorized'), 1),
                                            _createElementVNode("button", {
                                                class: "tag-btn",
                                                onClick: _withModifiers(($event) => (onTagClick(t)), ["stop"]),
                                                title: "Change category"
                                            }, [
                                                _createVNode(_component_v_icon, { size: "14" }, {
                                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                        _createTextVNode("mdi-pencil")
                                                    ])),
                                                    _: 1
                                                })
                                            ], 8, _hoisted_15)
                                        ]),
                                        _createElementVNode("div", _hoisted_16, [
                                            _createElementVNode("span", _hoisted_17, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.customerTags, (tag) => {
                                                    return (_openBlock(), _createElementBlock("span", {
                                                        key: tag.id,
                                                        class: "tag"
                                                    }, "#" + _toDisplayString(tag.tag), 1));
                                                }), 128))
                                            ]),
                                            (t.customerTags?.length)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.customerTags, (tag) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                            key: tag.id,
                                                            class: "tag"
                                                        }, "#" + _toDisplayString(tag.tag), 1));
                                                    }), 128))
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["col-amount", { positive: t.amount > 0 }])
                                        }, _toDisplayString(t.amount < 0 ? _ctx.formatter.format(t.amount * -1) : '+' + _ctx.formatter.format(t.amount)), 3)
                                    ], 14, _hoisted_8),
                                    _createVNode(_Transition, { name: "expand" }, {
                                        default: _withCtx(() => [
                                            (expandedTransactionId.value === t.id)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                    _createElementVNode("div", _hoisted_20, [
                                                        _createElementVNode("div", _hoisted_21, [
                                                            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "detail-label" }, "Date", -1)),
                                                            _createElementVNode("span", _hoisted_22, _toDisplayString(formatFullDate(t.timestamp)), 1)
                                                        ]),
                                                        (getTime(t.timestamp) !== '00:00:00')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "detail-label" }, "Time", -1)),
                                                                _createElementVNode("span", _hoisted_24, _toDisplayString(getTime(t.timestamp)), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("div", _hoisted_25, [
                                                            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "detail-label" }, "Transaction", -1)),
                                                            _createElementVNode("span", _hoisted_26, _toDisplayString(t.type === 'DEBIT' ? 'Money Out' : 'Money In'), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_27, [
                                                            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "detail-label" }, "Spending Analysis", -1)),
                                                            _createElementVNode("span", _hoisted_28, _toDisplayString(t.excludeFromAnalysis ? 'Excluded' : 'Included'), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_29, [
                                                            _cache[21] || (_cache[21] = _createElementVNode("span", { class: "detail-label" }, "Description", -1)),
                                                            _createElementVNode("span", _hoisted_30, _toDisplayString(t.description), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_31, [
                                                            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "detail-label" }, "#Tags", -1)),
                                                            _createVNode(TagInput, {
                                                                selectableTags: _ctx.availableTags,
                                                                modelValue: getSelectedTags(t),
                                                                maxTags: 5,
                                                                maxTagLength: 20,
                                                                onChange: (tags) => handleTagsChange(t, tags)
                                                            }, null, 8, ["selectableTags", "modelValue", "onChange"])
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ], 64));
                            }), 128))
                        ]));
                    }), 128))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(sortedTransactions.value, (t) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                            key: t.id
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["transaction-row", { expanded: expandedTransactionId.value === t.id, highlighted: _ctx.highlightedTransactionId === t.id || selectedTransactionId.value === t.id }]),
                                style: _normalizeStyle(gridStyle.value),
                                onClick: ($event) => (toggleExpand(t))
                            }, [
                                _createElementVNode("div", _hoisted_33, _toDisplayString(t.timestampString), 1),
                                _createElementVNode("div", _hoisted_34, _toDisplayString(t.merchant?.name || t.merchantName), 1),
                                _createElementVNode("div", _hoisted_35, _toDisplayString(t.description), 1),
                                _createElementVNode("div", _hoisted_36, [
                                    (getClassification(t)?.iconPath)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: require('@/assets/transactions/' + getClassification(t).iconPath.toLowerCase().replace('.svg', '.png')),
                                            class: "category-icon"
                                        }, null, 8, _hoisted_37))
                                        : (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            src: require('@/assets/round3.png'),
                                            class: "category-icon"
                                        }, null, 8, _hoisted_38)),
                                    _createElementVNode("span", null, _toDisplayString(getClassification(t)?.mgSubClassification || getClassification(t)?.mgClassification || 'Uncategorized'), 1),
                                    _createElementVNode("button", {
                                        class: "tag-btn",
                                        onClick: _withModifiers(($event) => (onTagClick(t)), ["stop"]),
                                        title: "Change category"
                                    }, [
                                        _createVNode(_component_v_icon, { size: "14" }, {
                                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                _createTextVNode("mdi-pencil")
                                            ])),
                                            _: 1
                                        })
                                    ], 8, _hoisted_39)
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("span", _hoisted_41, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.customerTags, (tag) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                                key: tag.id,
                                                class: "tag"
                                            }, "#" + _toDisplayString(tag.tag), 1));
                                        }), 128))
                                    ]),
                                    (t.customerTags?.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.customerTags, (tag) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                    key: tag.id,
                                                    class: "tag"
                                                }, "#" + _toDisplayString(tag.tag), 1));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["col-amount", { positive: t.amount > 0 }])
                                }, _toDisplayString(t.amount < 0 ? _ctx.formatter.format(t.amount * -1) : '+' + _ctx.formatter.format(t.amount)), 3)
                            ], 14, _hoisted_32),
                            _createVNode(_Transition, { name: "expand" }, {
                                default: _withCtx(() => [
                                    (expandedTransactionId.value === t.id)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                            _createElementVNode("div", _hoisted_44, [
                                                _createElementVNode("div", _hoisted_45, [
                                                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "detail-label" }, "Date", -1)),
                                                    _createElementVNode("span", _hoisted_46, _toDisplayString(formatFullDate(t.timestamp)), 1)
                                                ]),
                                                (getTime(t.timestamp) !== '00:00:00')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "detail-label" }, "Time", -1)),
                                                        _createElementVNode("span", _hoisted_48, _toDisplayString(getTime(t.timestamp)), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_49, [
                                                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "detail-label" }, "Transaction", -1)),
                                                    _createElementVNode("span", _hoisted_50, _toDisplayString(t.type === 'DEBIT' ? 'Money Out' : 'Money In'), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_51, [
                                                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "detail-label" }, "Spending Analysis", -1)),
                                                    _createElementVNode("span", _hoisted_52, _toDisplayString(t.excludeFromAnalysis ? 'Excluded' : 'Included'), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_53, [
                                                    _cache[28] || (_cache[28] = _createElementVNode("span", { class: "detail-label" }, "Description", -1)),
                                                    _createElementVNode("span", _hoisted_54, _toDisplayString(t.description), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_55, [
                                                    _cache[29] || (_cache[29] = _createElementVNode("span", { class: "detail-label" }, "#Tags", -1)),
                                                    _createVNode(TagInput, {
                                                        selectableTags: _ctx.availableTags,
                                                        modelValue: getSelectedTags(t),
                                                        maxTags: 5,
                                                        maxTagLength: 20,
                                                        onChange: (tags) => handleTagsChange(t, tags)
                                                    }, null, 8, ["selectableTags", "modelValue", "onChange"])
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 2
                            }, 1024)
                        ], 64));
                    }), 128)),
                (!_ctx.transactions?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.emptyMessage), 1)
                    ]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
